import React, { ReactNode, useEffect } from 'react';
import { FlagProvider, useUnleashClient } from '@unleash/proxy-client-react';
import { featureExposedEvent } from '../DataPipeline/DataPipeline';
import { UnleashEventType } from '../../types/unleash';
import { ErrorsService } from '../ErrorsService';

const { REACT_APP_FT_PROXY_API_URL, REACT_APP_FT_PROXY_SECRET, REACT_APP_ENV } = process.env;

const config = {
  url: REACT_APP_FT_PROXY_API_URL ?? '',
  clientKey: REACT_APP_FT_PROXY_SECRET ?? '',
  disableRefresh: true,
  appName: 'everyMother',
  environment: REACT_APP_ENV ?? '',
};

export const UnleashListenerEvents = (): null => {
  const unleashClient = useUnleashClient();
  const handleError = (err: unknown) => {
    ErrorsService.message(
      `[FeatureToggle] Unleash client error: ${err instanceof Error ? err.message : String(err)}`,
      { extra: { error: err, url: config.url } },
    );
  };
  useEffect(() => {
    if (unleashClient) {
      unleashClient.start();
      unleashClient.on('impression', (impressionEvent: UnleashEventType) => {
        featureExposedEvent({
          feature_name: impressionEvent.featureName,
          exposure_type: impressionEvent.eventType,
          variant: impressionEvent.variant ?? null,
          enabled: impressionEvent.enabled,
        });
      });
      unleashClient.on('error', handleError);
    }

    return () => {
      unleashClient.off('impression');
      unleashClient.off('error', handleError);
    };
  }, [unleashClient]);

  return null;
};

export const FeatureToggleProvider = ({ children }: { children: ReactNode }) => {
  return (
    <FlagProvider config={config}>
      <UnleashListenerEvents />
      {children}
    </FlagProvider>
  );
};
